<ng-container *ngIf="associateWallet; else elseAccount">
  <div class="modal-header border-0">
    <div class="d-flex w-100">
      <div class="col text-center">
        <strong class="fs-4">Vincular carteira a conta</strong>
        <p>Selecione a carteira que deseja vincular a conta</p>
      </div>
      <button type="button" class="btn-close" (click)="close()"></button>
    </div>
  </div>
  <div class="modal-body">
    <table class="table table-borderless">
      <thead class="align-middle">
        <tr class="table-primary">
          <th [style.width.%]="40">Contas</th>
          <th [style.width.%]="40">Carteira de investimento</th>
          <th [style.width.%]="15">%</th>
          <th [style.width.%]="5"></th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>{{model.name}}</td>
          <td>
            <select class="form-select" [(ngModel)]="rb_account.account_uuid" (change)="onSelectAccount($event)">
              <option [value]="undefined">Selecione uma carteira...</option>
              <option *ngFor="let item of accounts_filtered" [value]="item.account_uuid">
                {{item.name}}
              </option>
            </select>
          </td>
          <td>
            <input type="text" class="form-control fs-7" [(ngModel)]="rb_account.weight" [showPercentSymbol]="false" percentMask
              (blur)="onChangeWeights(i, d)" />
          </td>
          <td>
            <button type="button" class="btn btn-primary" (click)="submit()">Salvar</button>
          </td>
        </tr>
        <tr *ngFor="let item of model?.rb_accounts">
          <td>{{model.name}}</td>
          <td>{{item.name}}</td>
          <td>{{item.weight | percent: '1.2-2'}}</td>
          <td>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</ng-container>
<ng-template #elseAccount>
  <div class="modal-header border-0">
    <div class="d-flex w-100">
      <div class="col text-center">
        <strong class="fs-4">Vincular conta a carteira</strong>
        <p>Selecione a conta que deseja vincular a carteira</p>
      </div>
      <button type="button" class="btn-close" (click)="modalRef.hide()"></button>
    </div>
  </div>
  <div class="modal-body">
    <table class="table table-borderless">
      <thead class="align-middle">
        <tr class="table-primary">
          <th>Carteira de investimento</th>
          <th>Conta(s)</th>
          <th>%</th>
          <th></th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>
            <select class="form-select" [(ngModel)]="rb_account_uuid">
              <option [value]="undefined">Selecione uma carteira...</option>
              <option *ngFor="let item of rb_accounts" [value]="item.uuid">
                {{item.name}}
              </option>
            </select>
          </td>
          <td>
            <select class="form-select" [(ngModel)]="model.uuid">
              <option [value]="undefined">Selecione uma conta...</option>
              <option *ngFor="let item of connections" [value]="item.uuid">
                {{item.name}}
              </option>
            </select>
          </td>
          <td>100%</td>
          <td>
            <button type="button" class="btn btn-primary" (click)="addAccount()">Salvar</button>
          </td>
        </tr>
        <ng-container *ngFor="let wallet of rb_accounts">
          <tr *ngFor="let item of wallet?.connections">
            <td>{{wallet.name}}</td>
            <td>{{item.name}}</td>
            <td>100%</td>
            <td>
            </td>
          </tr>
        </ng-container>
      </tbody>
    </table>
  </div>
</ng-template>
<div class="d-flex justify-content-center my-4">
  <button type="button" class="btn btn-outline-dark" data-dismiss="modal" (click)="close()">FECHAR</button>
</div>